import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import Text from 'components/common/Text/Text'
import { APPOINTMENT_DURATION_DISCLOSURE_TEXT } from 'components/QuickAppointmentPage/BOTDateTimeSelector/components/DateTimeSelector/constants'


const AppointmentDurationDisclosure = ({ className, isQuotePage }) =>
  <Wrapper className={ className } isQuotePage={ isQuotePage }>
    <AppointmentDurationIcon asset="appointment-duration" />
    <InfoText>{ APPOINTMENT_DURATION_DISCLOSURE_TEXT }</InfoText>
  </Wrapper>

AppointmentDurationDisclosure.propTypes = {
  className: PropTypes.string,
  isQuotePage: PropTypes.bool
}

export default AppointmentDurationDisclosure

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 10px 17px 10px;
  margin: 15px auto 17px;
  ${({ isQuotePage }) => isQuotePage && css`
    margin: -15px auto 30px;
  `}
  border-radius: 60px;
  background: ${Theme.colors.white_smoke};

  @media (max-width: 1023px) {
    padding: 10px 8px 10px 17px;
    ${({ isQuotePage }) => isQuotePage && css`
      margin: 0 auto 30px;
    `}
  }

  @media (max-width: 600px) {
    margin: 15px -16px 17px;
    ${({ isQuotePage }) => isQuotePage && css`
      margin: 15px 0 17px;
    `}
  }
`

const AppointmentDurationIcon = styled(Icon)`
  position: absolute;
  left: 8px;
  width: 23px;
  height: 23px;
  ${Media.mobile`
    left: 6px;
    width: 22px;
    height: 22px;
  `}
`

const InfoText = styled(Text)`
  margin: 0 0 0 25px;
  font-size: 16px;
  ${Media.mobile`
    margin: 0 0 0 18px;
    font-size: 14px;
  `}
`
